// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-row_manage_slots_settings {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
  }
  
  .slot-label_manage_slots_settings {
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: var(--clr-grey-1);
  }
  
  .slot-dropdown_manage_slots_settings {
    padding: 0.6rem 0.75rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 100%;
    max-width: 100%;
    background-color: #fff;
    color: #333;
    outline: none;
    transition: border-color 0.2s ease;
  }
  
  .slot-dropdown_manage_slots_settings:focus {
    border-color:var(--clr-primary-5);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
  }
  
  /* Responsive Styling */
  @media (max-width: 768px) {
    .slot-row_manage_slots_settings {
      margin-bottom: 1rem;
    }
  
    .slot-dropdown_manage_slots_settings {
      font-size: 0.95rem;
      padding: 0.55rem 0.7rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/tabs/ManageSlots/manageSlotsParts/styles/PractitionerSelector.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;IACjC,6CAA6C;EAC/C;;EAEA,uBAAuB;EACvB;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;IACzB;EACF","sourcesContent":[".slot-row_manage_slots_settings {\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .slot-label_manage_slots_settings {\n    font-size: 0.95rem;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    color: var(--clr-grey-1);\n  }\n  \n  .slot-dropdown_manage_slots_settings {\n    padding: 0.6rem 0.75rem;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    width: 100%;\n    max-width: 100%;\n    background-color: #fff;\n    color: #333;\n    outline: none;\n    transition: border-color 0.2s ease;\n  }\n  \n  .slot-dropdown_manage_slots_settings:focus {\n    border-color:var(--clr-primary-5);\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n  }\n  \n  /* Responsive Styling */\n  @media (max-width: 768px) {\n    .slot-row_manage_slots_settings {\n      margin-bottom: 1rem;\n    }\n  \n    .slot-dropdown_manage_slots_settings {\n      font-size: 0.95rem;\n      padding: 0.55rem 0.7rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
